<template>
  <div>
    <div v-if="model != null">
<!--      <van-cell-group style="margin-top: 20px;">-->
<!--        <van-cell title="当前状态" is-link @click="statusActionSheet.show = true">-->
<!--            <span v-if="model.status == 1 && model.isVoiceActivated" class="text-green">在线 - 开启语音</span>-->
<!--            <span v-else-if="model.status == 1 && !model.isVoiceActivated" class="text-orange">在线 - 关闭语音</span>-->
<!--            <span v-else class="text-gray">离线</span>-->
<!--        </van-cell>-->
<!--      </van-cell-group>-->

      <van-cell-group style="margin-top: 20px;">
        <van-cell v-if="$hasFeature('custom_47') || $hasFeature('gaming_module')"
                    title="选择服务"
                    is-link
                    @click="()=>{ if(model.treeHoleStatus !== 0&&model.gamingStatus !== 0){$router.push('/clerk/updateItemType')}}">
          <van-tag v-if="model.treeHoleStatus == 0||model.gamingStatus == 0" plain type="primary" class="margin-right-xs">待审核</van-tag>
          <span v-if="model.itemType">
            <span v-if="model.itemType.includes('treeHole') && model.itemType.includes('gaming')">树洞、电竞</span>
            <span v-else>{{$store.state.ClerkItemTypeEnum.getLabel(model.itemType)}}</span>
          </span>
          <span v-else>树洞</span>
        </van-cell>
        <van-cell v-if="$hasFeature('custom_47') && model.itemType.includes('gaming')"
                  title="修改电竞资料"
                  is-link
                  @click="()=>{ $router.push('/clerk/gamingInfo')}">
          <span></span>
        </van-cell>
          <van-cell v-if=" $ClerkPermission.modifiableClerkAttr.includes('name')"
                    title="名称" clickable is-link style="display: flex;"
                    @click="()=>{if(model.nameStatus !== 0){updateNameDialog.name = model.name;updateNameDialog.show = true}}">

            <img v-if="$hasFeature('guild') && guildLogo" :src="guildLogo" height="20" class="margin-right-xs"  style="vertical-align:middle;" />
            <img v-if="$hasFeature('guild') && teamLogo" :src="teamLogo" height="20" class="margin-right-xs"  style="vertical-align:middle;" />
            <van-tag v-if="this.model.nameStatus == 0" plain type="primary" class="margin-right-xs">待审核</van-tag>
            {{model.name}}

          </van-cell>
          <van-cell v-else title="名称" style="display: flex;">
            <img v-if="$hasFeature('guild') && guildLogo" :src="guildLogo" height="20" class="margin-right-xs"  style="vertical-align:middle;" />
            <img v-if="$hasFeature('guild') && teamLogo" :src="teamLogo" height="20" class="margin-right-xs"  style="vertical-align:middle;" />
            <van-tag v-if="this.model.nameStatus == 0" plain type="primary" class="margin-right-xs">待审核</van-tag>
            {{model.name}}
          </van-cell>
<!--          <van-cell title="头像" center is-link clickable @click="model.picStatus !== 0 ?chooseImage(changeAvatar) : ''">-->
<!--&lt;!&ndash;            <div class="audit" v-if="this.model.picStatus == 0">待审核</div>&ndash;&gt;-->
<!--            <van-tag v-if="this.model.picStatus == 0" plain type="primary" class="margin-right-xs">待审核</van-tag>-->
<!--            <img :src="model.avatarUrl" width="40" height="40" style="border-radius: 5px;" />-->
            <van-uploader ref="imgUploader" v-show="false" accept = "image/*" :after-read="afterRead" />
<!--          </van-cell>-->
        <van-cell title="头像" center is-link clickable @click="toUpdateAvatar" >
          <van-tag v-if="this.model.picStatus == 0" plain type="primary" class="margin-right-xs">待审核</van-tag>
            <template v-if="model.avatarFrameUrl">
                <div style="box-sizing: border-box; padding: 10px; position: relative">
                    <div
                            style="
              position: absolute;
              left: 0;
              right: 0;
              top: 0;
              bottom: 0;
              margin: auto;
            ">
                        <img
                                :src="model.avatarFrameUrl" width="80px"
                                height="80px"/>
                    </div>
                    <img :src="model.avatarUrl" width="60" height="60" style="border-radius: 50%;" />
                </div>
            </template>
            <img v-else :src="model.avatarUrl" width="40" height="40" style="border-radius: 5px;" />
        </van-cell>
        <van-cell :title="$store.state.shop.id != 123 ? '相册' : '资料背景图'" title-style="flex:none;"
                    center is-link clickable :to="this.model.photoStatus != 0 ? '/clerk/updatePhotos' : ''">
<!--            <div class="audit"  v-if="this.model.photoStatus == 0">待审核</div>-->
            <van-tag v-if="this.model.photoStatus == 0" plain type="primary" class="margin-right-xs">待审核</van-tag>
            <img v-for="(item, index) in model.photoUrls" :src="item" width="40" height="40" style="border-radius: 5px;margin-left: 2px;" />
          </van-cell>
          <van-cell
              v-if="$hasFeature('clerk_home_video')"
            title="视频"
            value
            is-link
            clickable
            :to="model.videoStatus !== 0 ? '/clerk/uploadVideo' : ''"
          >
            <van-tag
              v-if="model.videoStatus === 0"
              plain
              type="primary"
              class="margin-right-xs"
            >审核中</van-tag>
          </van-cell>
          <van-cell title="录音" is-link clickable :to="this.model.soundStatus != 0 ? '/clerk/updateAudio' : ''">
<!--            <div class="audit"  v-if="this.model.soundStatus == 0">待审核</div>-->
            <van-tag v-if="this.model.soundStatus == 0" plain type="primary" class="margin-right-xs">待审核</van-tag>
            <span v-if="model.audioUrl == null || model.audioUrl == ''" >未上传录音</span>
              <van-button v-else class="btn-play-audio" size="mini" color="#666" plain @click.stop="playAudio(model.id, model.audioUrl)">
                  <div class="flex align-center">
                      <img :src="player.id == model.id ? iconAudioPlaying : iconAudio">{{player.id == model.id ? '停止' : '播放'}}
                  </div>
              </van-button>
          </van-cell>
        <van-cell v-if="$store.state.shop.id == 1 || $store.state.shop.id == 2073"  title="地址" value="" is-link clickable to="/clerk/location/address">
          {{model.address}}
        </van-cell>
        <van-cell v-if="hasSoundList"  title="声音" :value="clerkSoundIds? clerkSoundIds.length + '个': '未设置'" is-link clickable to="/clerk/updateSound">
        </van-cell>
        <van-cell
          v-if="$hasFeature('dispatch_order')"
          title="音色"
          value
          is-link
          clickable
          :to="model.soundCardStatus && model.soundCardStatus !== 0 ? '': '/clerk/dispatchOrder/soundCard'"
        >
          <van-tag
            v-if="model.soundCardStatus && model.soundCardStatus == 0"
            plain
            type="primary"
            class="margin-right-xs"
          >待审核</van-tag>
        </van-cell>
        <van-cell
        v-if="$hasFeature('clerk_circle')"
          title="才艺视频"
          value
          is-link
          clickable
          :to="model.talentVideoStatus == 0 ? '' : '/clerk/dispatchOrder/talentVideo'"
        >
          <van-tag
            v-if="model.talentVideoStatus == 0"
            plain
            type="primary"
            class="margin-right-xs"
          >待审核</van-tag>
        </van-cell>
        <van-cell v-if="$hasFeature('dispatch_order')"  title="游戏设置" value=""  is-link clickable to="/clerk/dispatchOrder/updateGameSetting">
        </van-cell>
        <van-cell  title="隐藏排名" v-if=" $ClerkPermission.modifiableClerkAttr.includes('hideRanking')">
          <van-switch v-model="model.isHideRanking"
                      size="24" @input="(input)=>updateIsHideRanking(input)"/>
        </van-cell>
        <van-cell  title="公众号邀请码" v-if="$hasFeature('clerk_point')">
          <van-button plain color="#1989fa" size="mini" @click="qrcodeClick()">
            <span style="margin: 8px">分享</span>
          </van-button>
        </van-cell>
        <!--          <van-cell title="等级" :value="$store.state.ClerkGradeMap[model.grade]" />-->
          <van-cell v-if=" $ClerkPermission.modifiableClerkAttr.includes('sex') && isEdit" title="性别" :value="$store.state.ClerkSexEnum.getLabel(model.sex) || '未设置'" is-link clickable @click="clickUpdateSex" />
          <van-cell v-else title="性别" :value="$store.state.ClerkSexEnum.getLabel(model.sex) || '未设置'" />
         <van-cell v-if="isEdit" title="年龄" :value="model.age != null ? model.age : '未设置'" is-link clickable @click="clerkUpdateAge" />
         <van-cell v-else title="年龄" :value="model.age != null ? model.age : '未设置'"/>

        <div v-if="[2073].includes($store.state.shop.id)">
          <van-cell v-if="isEdit" title="身高" :value="model.height != null ? model.height + '厘米': '未设置'" is-link clickable @click="clerkUpdateHeight" />
          <van-cell v-else title="身高" :value="model.height != null ? model.height : '未设置'"/>
          <van-cell v-if="isEdit" title="体重" :value="model.weight != null ? model.weight + '斤': '未设置'" is-link clickable @click="clerkUpdateWeight" />
          <van-cell v-else title="体重" :value="model.weight != null ? model.weight : '未设置'"/>
        </div>

        <van-cell :title="$store.state.shop.id != 123 ? $hasFeature('custom_47')&&model.itemType && model.itemType.includes($store.state.ClerkItemTypeEnum.EMOTION.value) ? '人生寄语' : '个性签名' : '关于我'" is-link clickable
                    @click="()=>{if(model.signatureStatus !== 0){updateSignatureDialog.signature = model.signature;updateSignatureDialog.show = true}}">
            <van-tag v-if="this.model.signatureStatus == 0" plain type="primary" class="margin-right-xs">待审核</van-tag>
            {{model.signature || '未设置'}}
          </van-cell>
        <template v-if="$hasFeature('custom_47')&&model.itemType && model.itemType.includes($store.state.ClerkItemTypeEnum.EMOTION.value)">
          <van-cell title="擅长领域" is-link clickable
                    @click="()=>{updateAreasExpertiseDialog.areasExpertise = model.areasExpertise;updateAreasExpertiseDialog.show = true}">
            {{model.areasExpertise || '未设置'}}
          </van-cell>

          <van-cell title="咨询风格" is-link clickable
                    @click="()=>{updateConsultStyleDialog.consultStyle = model.consultStyle;updateConsultStyleDialog.show = true}">
            {{model.consultStyle || '未设置'}}
          </van-cell>
        </template>

          <van-cell title="星座" :value="$store.state.ConstellationEnum.getLabel(model.constellation) || '未设置'" is-link clickable @click="constellationActionSheet.show = true" />
          <van-cell title="地区" :value="model.regionNames.length > 0 ? model.regionNames.join('-') : '未设置'" is-link clickable @click="$hasFeature('customization_1508') ? '' : areasPicker.show = true" />
          <van-cell title="标签" :value="model.tags ? '': '未设置'" is-link clickable :to="this.model.tagStatus != 0 ? '/clerk/updateTags' : ''">
            <van-tag v-if="this.model.tagStatus == 0" plain type="primary" class="margin-right-xs">待审核</van-tag>
            <van-tag v-for="(item,index) in model.tags" plain type="success" :key="index" style="margin: 1px;">{{ item }}</van-tag>
          </van-cell>
          <van-cell v-if="[1,127].includes($store.state.shop.id)" title="特质" value="" is-link clickable to="/clerk/updateCharacteristic">
          </van-cell>
          <template v-if="$store.state.shop.id != 123 && $hasFeature('clerk_category')">
            <van-cell  title="分类" :value="clerkCategoryIds ? clerkCategoryIds.length + '个': '未设置'" is-link clickable to="/clerk/updateCategory">
            </van-cell>
          </template>
        <van-cell title="微信工资收款码" center clickable @click="uploadCapitalCode('wechat')">
          <span v-if="_.has(model,'paymentQRCodeUrls.wechat')">修改</span>
          <span v-else>上传</span>
        </van-cell>
        <van-cell title="支付宝工资收款码" center clickable @click="uploadCapitalCode('alipay')">
          <span v-if="_.has(model,'paymentQRCodeUrls.alipay') ">修改</span>
          <span v-else>上传</span>
        </van-cell>
        <van-cell v-if="$store.state.shop.id === 1 || $store.state.shop.id === 127" title="微信号" style="display: flex;" @click="()=>{{updateWechatDialog.name = model.wechat;updateWechatDialog.show = true}}">
          {{model.wechat ? model.wechat : '修改'}}
        </van-cell>
        <van-cell title="微信二维码" center clickable @click="()=>{chooseImage(updateWechatCode)}">
          <span v-if="model.wechatCode">修改</span>
          <span v-else>上传</span>
        </van-cell>
        <van-cell title="实名认证" is-link center @click="openVerify">
          <template v-if="!model.requireVerify">
            <span>无需认证</span>
          </template>
          <template v-else>
            <span>{{model.isVerified? '已认证':'未认证'}}</span>
          </template>
        </van-cell>
      </van-cell-group>

    </div>

      <!-- 选择性别 -->
      <van-action-sheet
              v-model="sexActionSheet.show"
              title="修改性别"
              round
              :actions="sexActionSheet.actions"
              @select="onSexActionSheetSelect"
      />

  <!-- 选择星座 -->
  <van-action-sheet
          v-model="constellationActionSheet.show"
          title="修改星座"
          round
          :actions="constellationActionSheet.actions"
          @select="onConstellationActionSheetSelect"
  />

    <!-- 修改名称 -->
    <van-dialog
          v-model="updateNameDialog.show"
          title="修改名称"
          show-cancel-button
          :beforeClose="onUpdateNameDialogClose">
        <div class="padding-top-sm">
            <van-field v-model="updateNameDialog.name"
                       placeholder="请输入名称"
                       :maxlength="$store.state.shop.id === 2362 ? 30 : 8"
                       style="background: #f5f5f5;" />
        </div>
    </van-dialog>

      <!-- 修改年龄 -->
      <van-dialog
              v-model="updateAgeDialog.show"
              title="修改年龄"
              show-cancel-button
              :beforeClose="onUpdateAgeDialogClose">
          <div class="padding-top-sm">
              <van-field v-model="updateAgeDialog.age"
                         placeholder="请输入年龄"
                         maxlength="10"
                         style="background: #f5f5f5;" />
          </div>
      </van-dialog>

    <!-- 修改身高 -->
    <van-dialog
        v-model="updateHeightDialog.show"
        title="修改身高"
        show-cancel-button
        :beforeClose="onUpdateHeightDialogClose">
      <div class="padding-top-sm">
        <van-field v-model="updateHeightDialog.height"
                   placeholder="请输入身高"
                   maxlength="10"
                   style="background: #f5f5f5;" />
      </div>
    </van-dialog>

    <!-- 修改体重 -->
    <van-dialog
        v-model="updateWeightDialog.show"
        title="修改体重"
        show-cancel-button
        :beforeClose="onUpdateWeightDialogClose">
      <div class="padding-top-sm">
        <van-field v-model="updateWeightDialog.weight"
                   placeholder="请输入体重"
                   maxlength="10"
                   style="background: #f5f5f5;" />
      </div>
    </van-dialog>

    <!-- 修改个性签名 -->
    <van-dialog
          v-model="updateSignatureDialog.show"
          :title="signatureText"
          show-cancel-button
          :beforeClose="onUpdateSignatureDialogClose">
        <div class="padding-top-sm">
          <van-field v-model="updateSignatureDialog.signature"
                     type="textarea"
                     rows="2"
                     :placeholder="signaturePlaceholder"
                     :maxlength="signatureLength"
                     :show-word-limit="true"
                     style="background: #f5f5f5;" />
        </div>
    </van-dialog>

    <!-- 修改擅长领域 -->
    <van-dialog
          v-model="updateAreasExpertiseDialog.show"
          title="擅长领域"
          show-cancel-button
          :beforeClose="onUpdateAreasExpertiseDialogClose">
        <div class="padding-top-sm">
          <van-field v-model="updateAreasExpertiseDialog.areasExpertise"
                     type="textarea"
                     rows="2"
                     placeholder="请输入擅长领域"
                     :maxlength="20"
                     :show-word-limit="true"
                     style="background: #f5f5f5;" />
        </div>
    </van-dialog>

    <!-- 修改咨询风格 -->
    <van-dialog
          v-model="updateConsultStyleDialog.show"
          title="咨询风格"
          show-cancel-button
          :beforeClose="onUpdateConsultStyleDialogClose">
        <div class="padding-top-sm">
          <van-field v-model="updateConsultStyleDialog.consultStyle"
                     type="textarea"
                     rows="2"
                     placeholder="请输入咨询风格"
                     :maxlength="20"
                     :show-word-limit="true"
                     style="background: #f5f5f5;" />
        </div>
    </van-dialog>

    <!-- 修改头像 -->
    <van-dialog
          v-model="updateAvatarDialog.show"
          title="修改头像"
          show-cancel-button
          :beforeClose="updateAvatar">
      <div class="padding-tb-sm text-center">
          <img class="upload-img-preview" :src="updateAvatarDialog.avatar" >
      </div>
    </van-dialog>

    <!-- 选择地区 -->
    <van-popup v-model="areasPicker.show" position="bottom" :lazy-render="false">
      <van-picker
              ref="areasPicker"
              show-toolbar
              :columns="areasPicker.columns"
              @cancel="areasPicker.show = false"
              @change="onAreasPickerChange"
              @confirm="onAreasPickerConfirm"
      />
    </van-popup>
    <van-dialog v-model="promotionDialog.show" title="分享">
      <div class="qrbox">
        <vue-qr :logoSrc="promotionDialog.loge" :text="promotionDialog.url"
                ref="Qrcode"
                width="300"
                :key="promotionDialog.key"
                :correctLevel="0"
                :logoScale="0.22"
                :margin="50"
                :size="900"
                :logoCornerRadius="15"
                :logoMargin="10">
        </vue-qr>
      </div>
      <div style="width: 100%;text-align: center;padding-bottom: 5px;font-size: 14px;">
        <div style="color: red">每次生成的二维码有效期为30天</div>
        <div style="color: #999999">请长按保存二维码</div>
      </div>
    </van-dialog>

    <!-- 修改微信 -->
    <van-dialog
        v-model="updateWechatDialog.show"
        title="修改微信号"
        show-cancel-button
        :beforeClose="updateWechat">
      <div class="padding-top-sm">
        <van-field v-model="updateWechatDialog.name"
                   placeholder="请输入微信号"
                   maxlength="20"
                   style="background: #f5f5f5;" />
      </div>
    </van-dialog>

    <uploadImage ref="uploadImage"></uploadImage>
    <certification v-if="showVerify" @close="showVerify = false;loadData()"></certification>
  </div>
</template>

<script>
  import Vue from 'vue';
  import {Button, Cell, CellGroup, ActionSheet, Field, Popup, Picker, Tag, Toast, Dialog, Uploader, Switch} from 'vant';
  import Decimal from 'decimal.js';
  import moment from 'moment';
  import areas from '_pub/static/areas'
  import lrz from 'lrz'
  import { getClerk, updateConstellation, updateName, updateSex, updateAge, updateHeight, updateWeight, updateSignature, updateAvatar, updateRegion,
    updatePaymentCode,updateIsHideRanking,updateWechatCode,updateWechat,updateAreasExpertise,updateConsultStyle} from '@/api/clerk/clerk'
  import certification from "@/views/certification";
  import {wxgzhUrl} from "../../api/clerk/clerk";
  import {getShopSetting} from '@/api/global'
  import VueQr from 'vue-qr';
  import uploadImage from '@/components/uploadImage'


  Vue.use(Button)
        .use(Cell)
        .use(CellGroup)
        .use(ActionSheet)
        .use(Field)
        .use(Popup)
        .use(Picker)
        .use(Tag)
        .use(Toast)
        .use(Dialog)
        .use(Uploader)
        .use(Switch)

  export default {
    name: 'ClerkInfo',
    components:{
      certification,
      VueQr,
      uploadImage
    },
    data () {
      return {
        signatureLength: this.$store.state.shop.id === 2128 ? 200 : 30,
        signaturePlaceholder: null,
        signatureTitle: null,
        fileChangeCallback: null,
        showVerify: false,
        file:null,
        codeType: null,
        model: null,
        hasSoundList: null,
        clerkCategoryIds: [],
        clerkSoundIds: [],
        statusMap: {
          1: '在线',
          2: '离线'
        },
        statusActionSheet: {
          show: false,
          actions: [
            { name: '在线 - 开启语音', value: '1-1', color: '#07c160' },
            { name: '在线 - 关闭语音', value: '1-0', color: '#ff9900' },
            { name: '离线', value: '2-0', color: 'gray' }
          ],
          selected: null
        },
        sexActionSheet: {
          show: false,
          actions: [],
          selected: null
        },
        constellationActionSheet: {
          show: false,
          actions: [],
          selected: null
        },
        updateNameDialog: {
          show: false,
          name: null
        },
        updateWechatDialog: {
          show: false,
          name: null
        },
        updateAgeDialog: {
          show: false,
          age: null
        },
        updateHeightDialog: {
          show: false,
          height: null
        },
        updateWeightDialog: {
          show: false,
          weight: null
        },
        updateSignatureDialog: {
          show: false,
          signature: null
        },
        updateAreasExpertiseDialog: {
          show: false,
          areasExpertise: null
        },
        updateConsultStyleDialog: {
          show: false,
          consultStyle: null
        },
        updateAvatarDialog: {
          show: false,
          avatar: null
        },
        areasPicker: {
          show: false,
          columns: [
            {
              values: []
            },
            {
              values: []
            }
          ]
        },
        areaProvinceList: areas[86],
        iconAudio: require("../../assets/images/icon_audio.png"),
        iconAudioPlaying: require("../../assets/images/icon_audio_playing.gif"),
        player: {
          id: null,
          audio: null
        },
        guildLogo: null,
        teamLogo: null,
        checkedCategoryExamine: false,
        clerkJoinCategoryApply: false,
        promotionDialog: {
          show: false,
          url: null,
          name: null,
          loge: null,
          key: 0
        },
        minAge: null,
        maxAge: null,
        // 是否能修改
        isEdit: true,
        checkClerkSex: null,
      }
    },
    methods: {
      uploadCapitalCode(type){
        let that = this
        this.$refs.uploadImage.updateAvatar().then(localData=>{
          that.codeType = type
          that.updatePaymentCode(localData)
        })
      },

      qrcodeClick() {
        Toast.loading({
          mask: true,
          message: '生成中...'
        })
        wxgzhUrl().then(res => {
          Toast.clear()
          const data = res.data;
          if (data.code == 0) {
            this.promotionDialog.url = data.wxUrl
            this.promotionDialog.loge = data.logoUrl
            this.promotionDialog.key++
            this.promotionDialog.show = true
          } else {
            Dialog.alert({
              title: '加载失败',
              message: data.msg
            })
          }
        })
      },
      toUpdateAvatar(){
      // :to="this.model.photoStatus != 0 ? {path : 'updateAvatarUrl',query:{ url: this.model.avatarUrl}} : ''"
        if( this.model.picStatus != 0 ){
          this.$router.push({
            path : 'updateAvatarUrl',
            query: {
              url: JSON.stringify(this.model.avatarUrl)
            }
          })
        }
      },

      //点击隐藏排名
      updateIsHideRanking(isHideRanking){
        updateIsHideRanking(isHideRanking).then(res => {
          const data = res.data;
          if (data.code == 0) {
            this.model.isHideRanking = isHideRanking
            Toast('修改成功')

          } else {
            Dialog.alert({
              title: '修改失败',
              message: data.msg
            })
          }
        })
      },
      openVerify(){
        if(this.model.requireVerify){
          if(!this.model.isVerified){
            this.showVerify = true
          }else{
            Dialog.alert({
              title: '您已认证'
            })
          }
        }
      },
      //点击修改性别
      clickUpdateSex(){
        if (this.isEdit){
          this.sexActionSheet.show = true
        }
      },
      //点击修改年龄
      clerkUpdateAge(){
        if (this.isEdit){
          this.updateAgeDialog.age = this.model.age;
          this.updateAgeDialog.show = true
        }
      },
      //点击修改身高
      clerkUpdateHeight(){
        if (this.isEdit){
          this.updateHeightDialog.height = this.model.height;
          this.updateHeightDialog.show = true
        }
      },
      //点击修改体重
      clerkUpdateWeight(){
        if (this.isEdit){
          this.updateWeightDialog.weight = this.model.weight;
          this.updateWeightDialog.show = true
        }
      },
      formatDate(date, format) {
        if (!date) {
          return '';
        }
        if (!format) {
          format = 'YYYY-MM-DD'
        }
        return moment(date).format(format);
      },
      formatPrice(price) {
        if (price != null) {
          return Decimal.div(price, 100).toString()
        }
        return ''
      },
      afterRead(data){
        let vm = this;
        lrz(data.file, {
          width: 800
        }).then(function (res) {
          vm.fileChangeCallback(res.base64)
        })
      },
      changeAvatar(img){
        this.updateAvatarDialog.avatar = img
        this.updateAvatarDialog.show = true
      },
      onSexActionSheetSelect(item) {
        this.sexActionSheet.selected = item.value
        this.sexActionSheet.show = false;
        this.updateSex()
      },
      onConstellationActionSheetSelect(item) {
        this.constellationActionSheet.selected = item.value
        this.constellationActionSheet.show = false;
        this.updateConstellation()
      },
      onUpdateNameDialogClose(action, done) {
        if (action == 'confirm') {
          if (this.updateNameDialog.name == null || this.updateNameDialog.name == '') {
            Toast('名称不能为空');
            return done(false)
          }
          if (this.$store.state.shop.id === 2362 && this.updateNameDialog.name != null && this.updateNameDialog.name.length > 30) {
            Toast('名称不能超过30个字');
            return done(false)
          }
          if (this.$store.state.shop.id !== 2362 && this.updateNameDialog.name != null && this.updateNameDialog.name.length > 10) {
            Toast('名称不能超过10个字');
            return done(false)
          }
          Toast.loading({
            mask: true,
            message: '提交中...'
          })
          updateName(this.updateNameDialog.name).then(res => {
            Toast.clear()
            const data = res.data;
            if (data.code == 0) {
              Dialog.alert({
                title: '提交成功'
              }).then(() => {
                this.loadData();
              })
            } else {
              this.loadData()
              Dialog.alert({
                title: '修改昵称失败',
                message: data.msg
              })
            }
          })
          done()
        } else {
          done()
        }
      },
      onUpdateAgeDialogClose(action, done) {
        if (action == 'confirm') {
          if (this.updateAgeDialog.age == null || this.updateAgeDialog.age == '') {
            Toast('年龄不能为空');
            return done(false)
          }
          if (this.updateAgeDialog.age < this.minAge || this.updateAgeDialog.age > this.maxAge) {
            Toast('年龄限制区间为' + this.minAge + " - " + this.maxAge + "岁");
            return done(false)
          }
          updateAge(this.updateAgeDialog.age).then(res => {
            Toast.clear()
            const data = res.data;
            if (data.code == 0) {
              this.loadData()
              Dialog.alert({
                title: '修改年龄成功'
              })
            } else {
              this.loadData()
              Dialog.alert({
                title: '修改年龄失败',
                message: data.msg
              })
            }
          })
          done()
        } else {
          done()
        }
      },
      onUpdateHeightDialogClose(action, done) {
        if (action === 'confirm') {
          if (this.updateHeightDialog.height == null || this.updateHeightDialog.height === '') {
            Toast('身高不能为空');
            return done(false)
          }
          updateHeight(this.updateHeightDialog.height).then(res => {
            Toast.clear()
            const data = res.data;
            if (data.code === 0) {
              this.loadData()
              Dialog.alert({
                title: '修改身高成功'
              })
            } else {
              this.loadData()
              Dialog.alert({
                title: '修改身高失败',
                message: data.msg
              })
            }
          })
          done()
        } else {
          done()
        }
      },
      onUpdateWeightDialogClose(action, done) {
        if (action === 'confirm') {
          if (this.updateWeightDialog.weight == null || this.updateWeightDialog.weight === '') {
            Toast('体重不能为空');
            return done(false)
          }
          updateWeight(this.updateWeightDialog.weight).then(res => {
            Toast.clear()
            const data = res.data;
            if (data.code === 0) {
              this.loadData()
              Dialog.alert({
                title: '修改体重成功'
              })
            } else {
              this.loadData()
              Dialog.alert({
                title: '修改体重失败',
                message: data.msg
              })
            }
          })
          done()
        } else {
          done()
        }
      },
      onUpdateSignatureDialogClose(action, done) {
        if (action == 'confirm') {
          if (this.updateSignatureDialog.signature == null || this.updateSignatureDialog.signature == '') {
            Toast('个性签名不能为空');
            return done(false)
          }
          if (this.updateSignatureDialog.signature != null && this.updateSignatureDialog.signature.length > this.signatureLength) {
            Toast('个性签名不能超过'+this.signatureLength+'个字');
            return done(false)
          }
          Toast.loading({
            mask: true,
            message: '提交中...'
          })
          updateSignature(this.updateSignatureDialog.signature).then(res => {
            Toast.clear()
            const data = res.data;
            if (data.code == 0) {
              Dialog.alert({
                title: '提交成功'
              }).then(() => {
                this.loadData();
              })
            } else {
              this.loadData()
              Dialog.alert({
                title: '修改个性签名失败',
                message: data.msg
              })
            }
          })
          done()
        } else {
          done()
        }
      },
      onUpdateAreasExpertiseDialogClose(action, done) {
        if (action == 'confirm') {
          if (this.updateAreasExpertiseDialog.areasExpertise == null || this.updateAreasExpertiseDialog.areasExpertise == '') {
            Toast('擅长领域不能为空');
            return done(false)
          }
          if (this.updateAreasExpertiseDialog.areasExpertise != null && this.updateAreasExpertiseDialog.areasExpertise.length > 20) {
            Toast('擅长领域不能超过20个字');
            return done(false)
          }
          Toast.loading({
            mask: true,
            message: '提交中...'
          })
          updateAreasExpertise(this.updateAreasExpertiseDialog.areasExpertise).then(res => {
            Toast.clear()
            const data = res.data;
            if (data.code == 0) {
              Dialog.alert({
                title: '提交成功'
              }).then(() => {
                this.loadData();
              })
            } else {
              this.loadData()
              Dialog.alert({
                title: '修改擅长领域失败',
                message: data.msg
              })
            }
          })
          done()
        } else {
          done()
        }
      },
      onUpdateConsultStyleDialogClose(action, done) {
        if (action == 'confirm') {
          if (this.updateConsultStyleDialog.consultStyle == null || this.updateConsultStyleDialog.consultStyle == '') {
            Toast('咨询风格不能为空');
            return done(false)
          }
          if (this.updateConsultStyleDialog.consultStyle != null && this.updateConsultStyleDialog.consultStyle.length > 20) {
            Toast('咨询风格不能超过20个字');
            return done(false)
          }
          Toast.loading({
            mask: true,
            message: '提交中...'
          })
          updateConsultStyle(this.updateConsultStyleDialog.consultStyle).then(res => {
            Toast.clear()
            const data = res.data;
            if (data.code == 0) {
              Dialog.alert({
                title: '提交成功'
              }).then(() => {
                this.loadData();
              })
            } else {
              this.loadData()
              Dialog.alert({
                title: '修改咨询风格失败',
                message: data.msg
              })
            }
          })
          done()
        } else {
          done()
        }
      },
      getCityColumnValues(provinceCode) {
        const citys = areas[provinceCode]
        let values = []
        if (citys) {
          for (const key in citys) {
            values.push({
              text: citys[key],
              value: key
            })
          }
        }
        return values
      },
      onAreasPickerChange(picker, value, index) {
        if (index == 0) {
          picker.setColumnValues(1, this.getCityColumnValues(value[0].value));
        }
      },
      onAreasPickerConfirm(value, index) {
        const vm = this
        if (!value) {
          return Toast('请选择地区')
        }
        let regionNames = [value[0].text, value[1].text]
        let regionCodes = [value[0].value, value[1].value]

        Toast.loading({
          mask: true,
          message: '请稍候...'
        })
        updateRegion(
          JSON.stringify(regionNames),
          JSON.stringify(regionCodes)
        ).then(res => {
          Toast.clear()
          vm.areasPicker.show = false
          const data = res.data;
          if (data.code == 0) {
            this.model.regionNames = regionNames
            this.model.regionCodes = regionCodes
            Dialog.alert({
              title: '修改地区成功'
            })
          } else {
            this.loadData()
            Dialog.alert({
              title: '修改地区失败',
              message: data.msg
            })
          }
        })
      },
      chooseImage(callback) {
        this.fileChangeCallback = callback;
        this.$refs.imgUploader.chooseFile();
      },
      updateWechat(action,done){
        if (action == 'confirm') {
          if (this.updateWechatDialog.name == null || this.updateWechatDialog.name == '') {
            Toast('微信号不能为空');
            return done(false)
          }
          if (this.updateWechatDialog.name != null && this.updateWechatDialog.name.length > 20) {
            Toast('微信号不能超过20个字符');
            return done(false)
          }
          Toast.loading({
            mask: true,
            message: '请稍等'
          })
          updateWechat(this.updateWechatDialog.name).then(res => {
            Toast.clear()
            const data = res.data;
            if (data.code == 0) {
              this.loadData()
              Dialog.alert({
                title: '修改微信号成功'
              })
            } else {
              this.loadData()
              Dialog.alert({
                title: '修改微信号失败',
                message: data.msg
              })
            }
          })
          done()
        } else {
          done()
        }


      },
      updateWechatCode(img){
        if (img == null) {
          Toast('请上传二维码');
          return;
        }
        const qrcode = img;
        Toast.loading({
          mask: true,
          message: '上传二维码中'
        })
        updateWechatCode(qrcode.split(',')[1]).then(res => {
          Toast.clear()
          const data = res.data;
          if (data.code == 0) {
            this.loadData()
            Dialog.alert({
              title: '修改二维码成功'
            })
          } else {
            this.loadData()
            Dialog.alert({
              title: '修改二维码失败',
              message: data.msg
            })
          }
        })

      },
      updatePaymentCode(img){
        if (img == null) {
          Toast('请上传收款码');
          return;
        }
        const qrcode = img;
        Toast.loading({
          mask: true,
          message: '上传收款码中'
        })
        updatePaymentCode(this.codeType,qrcode.split(',')[1]).then(res => {
          Toast.clear()
          const data = res.data;
          if (data.code == 0) {
            this.loadData()
            Dialog.alert({
              title: '修改收款码成功'
            })
          } else {
            this.loadData()
            Dialog.alert({
              title: '修改收款码失败',
              message: data.msg
            })
          }
        })

      },
      updateAvatar(action, done) {
        if (action == 'confirm') {
          if (this.updateAvatarDialog.avatar == null) {
            Toast('请上传头像');
            return done(false)
          }
          const avatar = this.updateAvatarDialog.avatar;
          Toast.loading({
            mask: true,
            message: '上传头像中'
          })
          updateAvatar(avatar.split(',')[1]).then(res => {
            Toast.clear()
            const data = res.data;
            if (data.code == 0) {
              Dialog.alert({
                title: '提交成功'
              }).then(() => {
                this.loadData();
              })
            } else {
              this.loadData()
              Dialog.alert({
                title: '修改头像失败',
                message: data.msg
              })
            }
          })
          done()
        } else {
          done()
        }
      },
      updateSex() {
        Toast.loading({
          mask: true,
          message: '请稍候...'
        })
        updateSex(this.sexActionSheet.selected).then(res => {
          Toast.clear()
          const data = res.data;
          if (data.code == 0) {
            this.model.sex = this.sexActionSheet.selected
            Dialog.alert({
              title: '修改性别成功'
            })
          } else {
            this.loadData()
            Dialog.alert({
              title: '修改性别失败',
              message: data.msg
            })
          }
        })
      },
      updateConstellation() {
        Toast.loading({
          mask: true,
          message: '请稍候...'
        })
        updateConstellation(this.constellationActionSheet.selected).then(res => {
          Toast.clear()
          const data = res.data;
          if (data.code == 0) {
            this.model.constellation = this.constellationActionSheet.selected
            Dialog.alert({
              title: '修改星座成功'
            })
          } else {
            this.loadData()
            Dialog.alert({
              title: '修改星座失败',
              message: data.msg
            })
          }
        })
      },
      playAudio(id, audioUrl) {
        if (this.player.audio != null) {
          this.player.audio.pause()
        }
        if (this.player.id == id) {
          this.player.id = null
          this.player.audio = null
        } else {
          const audio = new Audio(audioUrl)
          audio.play()
          // 播放结束事件
          audio.onended = () => {
            this.player.id = null
            this.player.audio = null
          }
          this.player.id = id
          this.player.audio = audio
        }
      },
      loadData() {
        Toast.loading({
          mask: true,
          message: '加载中...'
        })
        getClerk().then(res => {
          Toast.clear()
          const data = res.data;
          if (data.code == 0) {
            this.model = data.clerk;
            this.signatureTitle = this.$store.state.shop.id != 123 ? this.$hasFeature('custom_47')&&this.model.itemType === this.$store.state.ClerkItemTypeEnum.EMOTION.value ? '修改人生寄语' :  '修改个性签名' : '修改关于我'
            this.signaturePlaceholder = this.$store.state.shop.id == 123 ? '请输入个性签名' : this.$hasFeature('custom_47')&&this.model.itemType === this.$store.state.ClerkItemTypeEnum.EMOTION.value ? '请输入人生寄语' : '请输入个性签名'
            // 判断店铺是否要实名 判断店铺是否开启自动更新店员年龄个性别 判断店员是否已经实名
            if(this.model.requireVerify && this.checkClerkSex && this.model.isVerified) {
              // 如果店铺要求实名且店员已经实名，则不允许修改
              this.isEdit = false
            }
            this.clerkCategoryIds = data.clerkCategoryIds
            this.clerkSoundIds = data.clerk.soundIds
            this.hasSoundList = data.hasSoundList
            this.guildLogo = data.guildLogo
            this.teamLogo = data.teamLogo
            this.checkedCategoryExamine = data.checkedCategoryExamine
            // 是否勾选加入技能需要申请
            this.clerkJoinCategoryApply = data.clerkJoinCategoryApply
          } else {
            Dialog.alert({
              title: '加载失败',
              message: data.msg
            })
          }
        })
      },
      // 拿到店铺对店员的年龄限制
      getShopSettings(){
        getShopSetting().then(res=>{
          const data= res.data;
          if(data.code==0){
            const setting = data.setting;
            this.minAge = setting.clerk.ageRestrict.minAge;
            this.maxAge = setting.clerk.ageRestrict.maxAge;
            this.checkClerkSex = setting.verify.checkClerkSex;
          }else{
            Dialog.alert({
              title: '获取店铺资料失败',
              message: data.msg
            })
          }
        })
      },
    },
    activated() {
      this.loadData()
    },
    mounted() {

      // 性别上拉菜单选项
      const sexList = this.$store.state.ClerkSexEnum.list()
      let sexActionSheetActions = []
      for (const item of sexList) {
        sexActionSheetActions.push({
          name: item.label,
          value: item.value
        })
      }
      this.sexActionSheet.actions = sexActionSheetActions

      // 星座上拉菜单选项
      const constellationList = this.$store.state.ConstellationEnum.list()
      let constellationActionSheetActions = []
      for (const item of constellationList) {
        constellationActionSheetActions.push({
          name: item.label,
          value: item.value
        })
      }
      this.constellationActionSheet.actions = constellationActionSheetActions

      // 地区picker选项
      const provinceMap = areas[86]
      let provinceColumnValues = []
      for (const key in provinceMap) {
        provinceColumnValues.push({
          text: provinceMap[key],
          value: key
        })
      }
      let cityColumnValues = this.getCityColumnValues(provinceColumnValues[0].value)
      const areasPicker = this.$refs.areasPicker
      areasPicker.setColumnValues(0, provinceColumnValues);
      areasPicker.setColumnValues(1, cityColumnValues);

      // 获取店铺的资料
      this.getShopSettings()
    },
    updated() {
      // 统一替换标签
      this.$replaceLabel(document.body, this.$store.state.label, true)
    }
  }
</script>

<style lang="less" scoped>
    .upload-img-preview {
        width: 200px;
        height: 200px;
        object-fit: contain;
        background: #e5e5e5;
        border-radius: 4px;
    }

    .btn-play-audio {
        img {
            height: 20px;
        }
    }

    /deep/.van-cell__title{
      flex: 0 0 auto;
    }

    /deep/.van-cell__value{
      display: block;
      justify-content: flex-end;
      align-items: center;
    }

    .audit{
      border: 1px solid deepskyblue;
      margin-right: 10px;
      padding: 0 5px;
      color: deepskyblue;
    }
    .qrbox {
      display: table;
      margin: 10px auto;
    }
</style>
